export enum DataGridViewType {
  dataTable = 'dataTable',
  treeDataGrid = 'treeDataGrid',
}
